<template>
  <v-app class="app">
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'App',

  data: () => ({
    //
  }),

  mounted(){
    
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Saira+Condensed:wght@100;200;300;400;500;600;700;800;900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Zen+Dots&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Russo+One&display=swap');

:root {
  --seham-bg: #020202;
  --seham-panel: #10100c;
  --seham-panel-soft: #19170f;
  --seham-line: rgba(246, 216, 74, 0.28);
  --seham-gold: #b59637;
  --seham-yellow: #f6d84a;
  --seham-yellow-soft: #fff1a8;
  --seham-text: #f8f6e9;
  --seham-muted: rgba(248, 246, 233, 0.68);
  --seham-gradient: linear-gradient(135deg, #2a2413 0%, #b59637 48%, #f6d84a 100%);
  --seham-gradient-dark: linear-gradient(135deg, rgba(246, 216, 74, 0.22) 0%, rgba(10, 9, 6, 0.88) 72%);
}

body{
   background-color: var(--seham-bg);
   color: var(--seham-text);
}

html { 
  overflow-y: auto !important;
  overflow-x: hidden !important;
}

.dt-container {
    border-radius: 10px !important;
    background: rgba(11, 10, 7, 0.94) !important;
    border: 1px solid var(--seham-line) !important;
    box-shadow: 0 18px 48px rgba(0, 0, 0, 0.34), 0 0 28px rgba(246, 216, 74, 0.08) !important;
    overflow: hidden;
}
.dt-container thead th {
    background: linear-gradient(135deg, rgba(10, 9, 6, 0.98), rgba(181, 150, 55, 0.24), rgba(246, 216, 74, 0.16)) !important;
    color: var(--seham-yellow-soft) !important;
}
.dt-container thead th:first-child {
    border-radius: 10px 0 0 0;
}

.dt-container thead th:last-child {
    border-radius: 0 10px 0 0;
}

.dt-container tr:nth-child(even) {
   background-color: rgba(246, 216, 74, 0.05);
}

.v-application {
  background: radial-gradient(circle at 18% 12%, rgba(246, 216, 74, 0.13), transparent 34%),
    radial-gradient(circle at 86% 6%, rgba(118, 95, 29, 0.2), transparent 30%),
    var(--seham-bg) !important;
  color: var(--seham-text) !important;
}

.v-card {
  background: linear-gradient(145deg, rgba(22, 20, 13, 0.97), rgba(5, 5, 4, 0.98)) !important;
  color: var(--seham-text) !important;
  border: 1px solid var(--seham-line) !important;
  box-shadow: 0 18px 45px rgba(0, 0, 0, 0.3), 0 0 28px rgba(246, 216, 74, 0.07) !important;
}

.v-btn.bg-primary,
.v-btn.bg-secondary {
  background: #f7cd45 !important;
  color: #000000 !important;
  font-weight: 800;
}

.v-chip.bg-secondary,
.v-progress-linear.bg-primary .v-progress-linear__determinate,
.v-progress-linear.bg-primary .v-progress-linear__indeterminate {
  background: var(--seham-gradient) !important;
}

.v-field {
  background: rgba(7, 9, 8, 0.84) !important;
  border-radius: 8px;
}

.v-field--focused .v-field__outline,
.v-input--focused .v-field__outline {
  color: var(--seham-yellow) !important;
}

.v-overlay__content .v-card-title {
  background: #f7cd45 !important;
  color: #000000 !important;
}

.v-overlay__content .v-card-title *,
.v-overlay__content .v-card-title.text-white,
.v-overlay__content .v-card-title .text-white {
  color: #000000 !important;
}

.v-overlay__content .v-card-title .v-icon {
  color: #000000 !important;
}


/* ::-webkit-scrollbar {
  width: 8px;
} */

/* Track */
/* ::-webkit-scrollbar-track {
  background: '#F5F5F5';
} */

/* Handle */
/* ::-webkit-scrollbar-thumb {
  background: '#F5F5F5';
  border-radius: 10px;
} */

/* Handle on hover */
/* ::-webkit-scrollbar-thumb:hover {
  background: '#F5F5F5';
} */

@keyframes fadeIn {
    0%{
       opacity: 0;
       transform: translateZ(0);
    }
    100%{
       opacity: 1;
       transform: translateZ(100%)
    }
}

@keyframes viewUp {
    0%{
       opacity: 0;
       transform: translateY(0);
    }
    50%{
       opacity: 0.5;
       transform: translateY(12px)
    }
    100%{
       opacity: 1;
       transform: translateY(0)
    }
}

.doughnut-style {
    width:110px;
    height:110px;
    margin: 7px;
}

.toggle{
    -webkit-animation-name: fadeIn;
    animation-name: fadeIn;
}

.animated{
  -webkit-animation-duration: 0.8s;
  animation-duration: 0.8s;
}

@media (max-width: 960px) {
  .v-data-table-headers--mobile {
    display: none;
  }
}
</style>
